module.exports = __webpack_public_path__ + "img/hager-logo.4971fee1.jpg";